import { DocumentNode, ApolloClient, NormalizedCacheObject } from '@apollo/client';

export function createObserver<
    T,
    A extends ApolloClient<NormalizedCacheObject> = ApolloClient<NormalizedCacheObject>,
>(apolloClient: A, query: DocumentNode, handler: (data: T) => void, error: (err: unknown) => void) {
    return function start() {
        const observable = apolloClient.subscribe<T>({
            query,
        });
        return observable.subscribe({
            next: data => (data?.data ? handler(data.data) : error('no data received')),
            error,
        });
    };
}
